import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock, Instagram, Facebook } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-20 md:py-32 bg-brand-white" data-id="element-34">
      <div className="container mx-auto px-4 md:px-6" data-id="element-35">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20" data-id="element-36">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 h-[400px] lg:h-auto min-h-[400px] rounded-xl overflow-hidden shadow-lg border border-gray-100 bg-gray-100 relative" data-id="element-37">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3340.5!2d-112.0465!3d33.058!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDAzJzI4LjgiTiAxMTLCsDAyJzQ3LjQiVw!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus&q=45004+W+Garvey+Ave,+Maricopa,+AZ+85139" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="K'Bella Spa & Wellness Location" className="absolute inset-0 w-full h-full" data-id="element-38"></iframe>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full lg:w-1/2 flex flex-col justify-center" data-id="element-39">
            <div className="w-16 h-1 bg-brand-teal mb-6" data-id="element-40"></div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-brand-charcoal mb-8" data-id="element-41">
              Visit K'Bella
            </h2>

            <div className="space-y-8" data-id="element-42">
              <div className="flex items-start gap-4" data-id="element-43">
                <div className="w-12 h-12 rounded-full bg-brand-blush flex items-center justify-center text-brand-coral shrink-0" data-id="element-44">
                  <MapPin className="w-5 h-5" data-id="element-45" />
                </div>
                <div data-id="element-46">
                  <h3 className="font-heading font-semibold text-xl text-brand-charcoal mb-1" data-id="element-47">
                    Location
                  </h3>
                  <p className="text-brand-charcoal/70 leading-relaxed" data-id="element-48">
                    K'Bella Spa & Wellness
                    <br data-id="element-49" />
                    45004 West Garvey Avenue
                    <br data-id="element-50" />
                    Maricopa, Arizona 85139
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-51">
                <div className="w-12 h-12 rounded-full bg-brand-blush flex items-center justify-center text-brand-coral shrink-0" data-id="element-52">
                  <Phone className="w-5 h-5" data-id="element-53" />
                </div>
                <div data-id="element-54">
                  <h3 className="font-heading font-semibold text-xl text-brand-charcoal mb-1" data-id="element-55">
                    Phone
                  </h3>
                  <a href="tel:5202338576" className="text-brand-charcoal/70 hover:text-brand-teal transition-colors" data-id="element-56">
                    (520) 233-8576
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-57">
                <div className="w-12 h-12 rounded-full bg-brand-blush flex items-center justify-center text-brand-coral shrink-0" data-id="element-58">
                  <Mail className="w-5 h-5" data-id="element-59" />
                </div>
                <div data-id="element-60">
                  <h3 className="font-heading font-semibold text-xl text-brand-charcoal mb-1" data-id="element-61">
                    Email
                  </h3>
                  <a href="mailto:kbellaspawellness@gmail.com" className="text-brand-charcoal/70 hover:text-brand-teal transition-colors" data-id="element-62">
                    kbellaspawellness@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-63">
                <div className="w-12 h-12 rounded-full bg-brand-blush flex items-center justify-center text-brand-coral shrink-0" data-id="element-64">
                  <Clock className="w-5 h-5" data-id="element-65" />
                </div>
                <div data-id="element-66">
                  <h3 className="font-heading font-semibold text-xl text-brand-charcoal mb-1" data-id="element-67">
                    Hours
                  </h3>
                  <p className="text-brand-charcoal/70 font-medium text-brand-teal" data-id="element-68">
                    By Appointment Only
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-10 pt-10 border-t border-gray-200" data-id="element-69">
              <h3 className="font-heading font-semibold text-xl text-brand-charcoal mb-4" data-id="element-70">
                Follow Us
              </h3>
              <div className="flex gap-4" data-id="element-71">
                <a href="#" className="w-12 h-12 rounded-full bg-brand-charcoal flex items-center justify-center text-white hover:bg-brand-teal transition-colors" aria-label="Instagram" data-id="element-72">
                  <Instagram className="w-5 h-5" data-id="element-73" />
                </a>
                <a href="#" className="w-12 h-12 rounded-full bg-brand-charcoal flex items-center justify-center text-white hover:bg-brand-teal transition-colors" aria-label="Facebook" data-id="element-74">
                  <Facebook className="w-5 h-5" data-id="element-75" />
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}